import { BookmarkNode, DocumentMapNode, RenderingExtension } from './';

export class DocumentInfo {
    public documentReady: boolean = false;
    public documentMapAvailable: boolean = false;
    public containsFrozenContent: boolean = false;
    public pageCount: number = 0;
    public documentMapNodes: DocumentMapNode[] = [];
    public bookmarkNodes: BookmarkNode[] = [];
    public renderingExtensions: RenderingExtension[] = [];
    public autoRunEnabled?: boolean = true;
}
